import React, { useEffect, useState } from 'react'
import FilmsDetails from './FilmsDetails'
import PostDetails from './PostDetails'
import TeamDetails from './TeamDetails'

const Single = ({ data }) => {
    const [content, updateContent] = useState(null)
    useEffect(() => {
        if (data) {
            let output = null
            const cat = (data.categories && data.categories[0]) || ''

            switch (cat) {
            case 'films':
                output = <FilmsDetails data={data} />
                break
            case 'features':
                output = <PostDetails data={data} />
                break
            default:
                output = <TeamDetails data={data} />
                break
            }
            updateContent(output)
        }
    }, [data])

    return content
}

export default Single
